import * as yup from 'yup';

// Define your Yup validation schema
const schema = yup.object({
  debug: yup.boolean().default(false),
  auth0: yup.object({ clientId: yup.string().required() }),
  api: yup.object({
    cubeApiUrl: yup.string().required(),
    bloomfieldApiUrl: yup.string().required(),
    imageUrl: yup.string().required(),
    cloudfrontScanDataUrl: yup.string().required(),
    wranglerUrl: yup.string().required(),
  }),
  mapbox: yup.object({
    apiKey: yup.string().required(),
  }),
  locize: yup.object({
    projectID: yup.string().required(),
    apiKey: yup.string(),
    referenceLanguage: yup.string().required(),
  }),
  sentry: yup.object({
    dsn: yup.string().required(),
  }),
  launchDarkly: yup.object({
    clientId: yup.string().required(),
  }),
});

type Config = yup.InferType<typeof schema>;

// Create a dummy variable that matches the validation schema to use on GitHub Actions to pass tests
const dummyVariable: Config = {
  debug: false,
  auth0: {
    clientId: 'dummyClientId',
  },
  api: {
    cubeApiUrl: 'http://dummy.url',
    bloomfieldApiUrl: 'http://dummy.url',
    imageUrl: 'http://dummy.url',
    cloudfrontScanDataUrl: 'http://dummy.url',
    wranglerUrl: 'http://dummy.url',
  },
  mapbox: {
    apiKey: 'dummyApiKey',
  },
  locize: {
    projectID: 'dummyProjectID',
    referenceLanguage: 'en',
  },
  sentry: {
    dsn: 'dummyDsn',
  },
  launchDarkly: {
    clientId: 'dummyLaunchDarklyClientId',
  },
};

// Create the input config object
const inputConfig: Config = {
  debug: import.meta.env.VITE_DEBUG,
  auth0: {
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  },
  api: {
    cubeApiUrl: import.meta.env.VITE_CUBE_API_URL,
    bloomfieldApiUrl: import.meta.env.VITE_BLOOMFIELD_API_URL,
    imageUrl: import.meta.env.VITE_IMAGE_URL,
    cloudfrontScanDataUrl: import.meta.env.VITE_CLOUDFRONT_SCANDATA_URL,
    wranglerUrl: import.meta.env.VITE_WRANGLER_URL,
  },
  mapbox: {
    apiKey: import.meta.env.VITE_MAPBOX_API_KEY,
  },
  locize: {
    projectID: import.meta.env.VITE_LOCIZE_PROJECT_ID,
    apiKey: import.meta.env.VITE_LOCIZE_API_KEY,
    referenceLanguage: import.meta.env.VITE_LOCIZE_REFERENCE_LANGUAGE,
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
  },
  launchDarkly: {
    clientId: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID,
  },
};

// Check if we are running in GitHub Actions
const isGitHubActions = import.meta.env.CI === 'true';

let config: Config;

// Try to validate if not in GitHub Actions, otherwise use inputConfig
try {
  config = isGitHubActions ? dummyVariable : schema.validateSync(inputConfig);
} catch (err) {
  // If validation fails and it's not GitHub Actions, throw the error.
  if (!isGitHubActions) throw err;
  config = dummyVariable; // fallback to inputConfig if in GitHub Actions
}

export default config;
